'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (length) {
  return function (value) {
    if (Array.isArray(value)) return value.length === 0 || value.length <= length;

    return value === undefined || value === null ? true : value === '' || String(value).length <= length;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/maxLength.js
// module id = ./node_modules/vuelidate/lib/validators/maxLength.js
// module chunks = 0